import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Inject, Input
} from '@angular/core';
import { MatPaginator, MatSort, PageEvent, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatInput, MatSortable } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { AppStateService } from '../../services/app-state.service';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data.service';
import { environment } from '../../../environments/environment';
import { Timereport } from './../interfaces';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/merge';
import { AuthService } from '../../services/auth.service';
import { FormControl, Validators } from '@angular/forms';
import { Moment } from 'moment';
import { ProjectNrPipe } from '../../shared/pipes/project-nr.pipe';

@Component({
  selector: 'timereport-list',
  templateUrl: './timereport-list.component.html',
  styleUrls: ['./timereport-list.component.scss']
})
export class TimereportListComponent implements OnInit, OnDestroy, AfterViewInit {
  // For the mat-table
  displayedColumns = ['sent', 'budgetId', 'activityId', 'hours', 'date', 'userId', 'description', 'actions'];
  dataSource: TimereportDataSource;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('fromDate', {
    read: MatInput
  }) fromDate: MatInput;
  
  @ViewChild('toDate', {
    read: MatInput
  }) toDate: MatInput;

  // Set our default values
  public localState = { value: '' };
  public hiddenvalue = 0;
  public timereports: Timereport[] = [];
  public sendReportDisabled = false;

  private userId;
  private dataSubscription;
  private timereportStream$;
  private _sentDates = new Set([]);

  @Input() set sentDates(sd: Set<number>) {
    this._sentDates = sd;
  }

  private canChangeUser;

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private router: Router,
    public dialog: MatDialog,
    public appState: AppStateService,
    private projectNrPipe: ProjectNrPipe
  ) { }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  public getListFilter() {
    let listFilter = localStorage.getItem('timereportListFilter') ? localStorage.getItem('timereportListFilter') : '';
    this.applyFilter(listFilter);
    return listFilter;
  }

  public setListFilter(filterName, filterValue) {
    localStorage.setItem(filterName, filterValue);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
    this.setListFilter('timereportListFilter', filterValue);
  }

  filterByFromDate(filterValue: Date) {
    let fromDate = new Date(filterValue).getTime();
    this.dataSource.filterFromValidDate = fromDate;    
  }

  filterByToDate(filterValue: Date) {
    let toDate = new Date(filterValue).getTime();
    this.dataSource.filterToValidDate = toDate;
  }

  resetDatePicker() {
    this.fromDate.value = '';
    this.dataSource.filterFromValidDate = undefined;  
    this.toDate.value = '';
    this.dataSource.filterToValidDate = undefined;  
  };

  public ngOnInit() {

    let trSnapshotChanges;

    const currentUser = this.authService.currentUser;

    trSnapshotChanges = this.authService.userHasPermission('app.timereport.anyone.write')
    .do((val) => {
      this.canChangeUser = val;
    })
    .switchMap(val => {
      if (val) {
        return this.dataService.getTimereportList();
      } else {
        return this.dataService.getTimereportList(currentUser);
      }
    });

    this.timereportStream$ = trSnapshotChanges.map((trList) => trList.map((tr) => {
      const data = tr.payload.doc.data() as Timereport;
      const id = tr.payload.doc.id;
      return { id: id, ...data };
    }));
    // .do(reports => {
    //   console.log('reports', reports);
    // });


    // Assign the data to the data source for the table to render
    this.dataSource = new TimereportDataSource(
      this.timereportStream$,
      this.paginator, this.sort, this.projectNrPipe);
  }

  public deleteTimereport($event: Event, tr: Timereport) {
    $event.stopPropagation();
    this.appState.confirmDialog({ confirmMessage: 'Timereport will be deleted' })
      .then((result) => {
        if (result && result.confirm) {
          return this.dataService.deleteTimereport(tr);
        } else {
          return Promise.resolve();
        }
      })
      .then((d) => {
        if (!d) {
          // DO NOTHING
        } else {
          console.log('Timereport Deleted', d);
        }
      });
      return false;
  }

  public editTimereport($event: Event, tr: Timereport) {
    $event.stopPropagation();
    this.router.navigate(['/timereport', tr.id]);
    return false;
  }


  sendDailyReport() {

    if (!this.authService.currentUser) {
      this.appState.showError({ errorMessage: 'Current user not defined', errorCode: -1 });
      return;
    }

    this.sendReportDisabled = true;
    const dialogRef = this.dialog.open(SendReportDialogComponent, {
      width: '550px',
      data: {
        sentDates: this._sentDates,
        canChangeUser: this.canChangeUser,
        user: this.authService.currentUser
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed ', result);
      // this.animal = result;
      if (!result) {
        this.sendReportDisabled = false;
        return;
      }
      this.dataService.sendDailyReport(result)
        .subscribe((data: any) => {
          console.log('Report sent', data);
          this.sendReportDisabled = false;
          this.appState.infoDialog({ infoMessage: 'Report sent', infoHtmlDetail: data.emailBody });
        }, (err) => {
          this.sendReportDisabled = false;
          this.appState.showError({ errorMessage: err.message, errorCode: -1 });
        });
    });
  }

  public ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }


  public setTimereports(data) {
    return [];
  }

}

/**
* Data source to provide what data should be rendered in the table. Note that the data source
* can retrieve its data in any way. In this case, the data source is provided a reference
* to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
* the underlying data. Instead, it only needs to take the data and send the table exactly what
* should be rendered.
*/
class TimereportDataSource extends DataSource<Timereport> {

  _filterChange = new BehaviorSubject('');
  _filterFromValidDateChange = new BehaviorSubject(undefined);
  _filterToValidDateChange = new BehaviorSubject(undefined);
  _dataChange = new BehaviorSubject([]);
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }
  get filterFromValidDate(): number { return this._filterFromValidDateChange.value; }
  set filterFromValidDate(filterFromValidDate: number) { this._filterFromValidDateChange.next(filterFromValidDate); }
  get filterToValidDate(): number { return this._filterToValidDateChange.value; }
  set filterToValidDate(filterToValidDate: number) { this._filterToValidDateChange.next(filterToValidDate); }

  // The number of issues returned by github matching the query.
  public resultsLength = 0;
  public isLoadingResults = false;

  constructor(private observable,
    private _paginator: MatPaginator,
    private _sort: MatSort,
    private projectNrPipe:  ProjectNrPipe) {
    super();
    this.observable.subscribe(this._dataChange);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Timereport[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.observable,
      this._sort.sortChange,
      this._filterChange.debounceTime(500),
      this._filterFromValidDateChange,
      this._filterToValidDateChange,
      this._paginator.page,
    ];

    this._paginator._changePageSize(Number(localStorage.getItem('timeReportListPageSize')))
    this._paginator.page.next(new PageEvent());
    this._paginator.page.subscribe(paginationData => {
      localStorage.setItem('timeReportListPageSize', paginationData.pageSize);
    })

    const sortId = localStorage.getItem('timeReportListSortId');
    const sortDirection = localStorage.getItem('timeReportListSortDirection');

    this._sort.sort(({ id: sortId, start: sortDirection }) as MatSortable);

    return Observable.merge(...displayDataChanges).map(() => {
      // console.log('Combine ', data, filter, page);
      const data = this._dataChange.value;

      // ???????????????????????????????
      // Filter
      const fData = data.filter((item: Timereport) => {
        if (!item.activity) {
          return false;
        }
        
        let timestampDate = this.extractDateFromTimestamp(item.date);
        let fromValidDate = this.filterFromValidDate ? timestampDate >= this.filterFromValidDate : true;
        let toValidDate = this.filterToValidDate ? timestampDate <= this.filterToValidDate : true;
        
        let searchStr = (item.budget.budgetNr + item.activity.activity + item.user.displayName).toLowerCase();
        if (item.budget.project) {
          searchStr += this.projectNrPipe.transform(item.budget).toLowerCase();
        }
        return searchStr.indexOf(this.filter.toLowerCase()) !== -1 && fromValidDate && toValidDate;
      });

      this.resultsLength = fData.length;
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.sortData(fData);
      return fData.splice(startIndex, this._paginator.pageSize);
    });

  }

  extractDateFromTimestamp(date) {
    let dateTime = new Date(date.toString());
    let year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    let day = dateTime.getDate();
    return new Date(year + "-" + month + "-" + day).getTime();
  }

  disconnect() { }

  private sortData = (timereport: Timereport[]) => {
    // console.log('sort ', this._sort.active, this._sort.direction);
    localStorage.setItem('timeReportListSortId', this._sort.active);
    localStorage.setItem('timeReportListSortDirection', this._sort.direction);
    if (this._sort.active === undefined || this._sort.direction === undefined) {
      return;
    }
    timereport.sort((a: Timereport, b: Timereport) => {

      let propertyA: number | string | Date = '';
      let propertyB: number | string | Date = '';

      switch (this._sort.active) {
        case 'budget':
          const abid = (typeof a.budget === 'object') ? a.budget.budgetNr : a.budget;
          const bbid = (typeof b.budget === 'object') ? b.budget.budgetNr : b.budget;
          [propertyA, propertyB] = [abid, bbid];
          break;
        case 'userId': [propertyA, propertyB] = [a.user.displayName, b.user.displayName]; break;
        case 'activity': [propertyA, propertyB] = [a.activity.activity, b.activity.activity]; break;
        case 'hours': [propertyA, propertyB] = [a.hours, b.hours]; break;
        case 'date': [propertyA, propertyB] = [a.date, b.date]; break;
        case 'user': [propertyA, propertyB] = [a.user.email, b.user.email]; break;
      }

      let valueA;
      let valueB;

      if (propertyA instanceof Date) {
        valueA = propertyA;
        valueB = propertyB;
      } else {
        valueA = isNaN(+propertyA) ? propertyA : +propertyA;
        valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      }

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}


@Component({
  selector: 'app-send-report-dialog',
  template: `<h3 mat-dialog-title i18n>Send Report</h3>
<mat-dialog-content>
    <app-user-picker placeholder="Select an user" [myControl]="employee" [readonly]="userReadOnly"></app-user-picker>
    <mat-form-field>
        <input matInput [max]="maxDate"
        [matDatepickerFilter]="dateFilter"
        [matDatepicker]="picker" placeholder="Report Date" i18n-placeholder required
        [formControl]="reportDateControl" name="deliveryDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
        <button type="submit" mat-button (click)="closeDialog()" i18n>Send report</button>
</mat-dialog-actions>
  `
})
export class SendReportDialogComponent implements OnInit {

  public employee: FormControl = new FormControl(undefined, Validators.required);
  public reportDateControl: FormControl = new FormControl(undefined, Validators.required);
  public maxDate = new Date();

  public userReadOnly = false;

  constructor(
    public dialogRef: MatDialogRef<SendReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (!this.data.canChangeUser) {
      this.employee.setValue(this.data.user);
      this.userReadOnly = true;
    } else {
      this.dateFilter = undefined;
    }
  }

  public dateFilter = (d: Moment | null): boolean => {
    if (!this.data.sentDates) {
      return false;
    }
    return !this.data.sentDates.has(d.valueOf());
  }

  closeDialog() {
    if (this.validateForm()) {
      this.dialogRef.close({
        user: this.data.canChangeUser ? this.employee.value : this.data.user,
        reportDate: this.reportDateControl.value
      });
    } else {
      console.log('Invalid');
    }
  }

  private validateForm() {
    return this.reportDateControl.valid && (!this.data.canChangeUser || this.employee.valid);
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/timereport/timereport-list/timereport-list.component.ts